import React from 'react'
import cover_photo from './cover_photo.png';
import { verify, resetPassword } from '../../Controllers/Auth'
import { useNavigate } from 'react-router-dom';
import { UnstyledButton } from '../../common_components/Button';
import mainContext from '../../contexts/mainContext';
import { __snackBarSeverity, __snackBarText } from '../../constants';

const ResetPassword = () => {
    const [buttonLoader, setButtonLoader] = React.useState(false);
    const { setSnackBar } = React.useContext(mainContext);
    const url = new URLSearchParams(window.location.search);
    const [tokenExpired, setTokenExpired] = React.useState(true);
    const navigate = useNavigate();
    const checkVerify = async () => {
        const res = await verify(url.get("token"));
        
        if (res && res.status === 500) {
            return alert("Internal server error");
        }
        if (res.data.data.tokenStatus === "expired") {
            return alert(res.data.data.message)
        }
        setTokenExpired(false);
    }
    const handleUpdatePassword = async (e) => {
        setButtonLoader(true);
        const newPassword = document.getElementById("newPassword").value;
        const confirmPassword = document.getElementById("confirmPassword").value;

        if (newPassword !== confirmPassword) {
            setButtonLoader(false);
            return alert("passwords not match");
        }

        const res = await resetPassword({
            token: url.get("token"),
            newPassword
        });

        if (res && res.status === 500) {
            setButtonLoader(false);
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            });
        }
        if (res.data.status !== 200) {
            setButtonLoader(false);
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message || __snackBarText.unKnownError,
                severity: __snackBarSeverity.error
            });
        }
        setSnackBar({
            status: true,
            text: "Password change successfully, now you can login with new password",
            severity: __snackBarSeverity.success
        })
        return navigate("/login");
    }

    React.useLayoutEffect(() => {
        checkVerify()
    }, [])
    return (
        <>
            {
                tokenExpired ?
                    <>
                        Your token expired
                    </>
                    :

                    <div className="login_page_main_div">
                        <div className="left_section" >
                            <div className="login_section">
                                <div className="logo">
                                    <div className='img_div'>
                                        <img src="/assets/logo.svg" alt="" />
                                    </div>
                                    <h4>ADMIN PANEL</h4>
                                </div>
                                <div className="login_text">
                                    <h3 style={{ marginBottom: "6px" }}>Reset password</h3>
                                    <p>Thanks for verify your email address. Add your new updated password</p>
                                </div>
                                <div className="login_form">
                                    <label htmlFor="newPassword">New password</label>
                                    <input maxLength={30} type="password" id="newPassword" placeholder="enter new password" />
                                    <label htmlFor="confirmPassword">Confirm password</label>
                                    <input maxLength={30} type="password" id='confirmPassword' placeholder="enter confirm password" />
                                    <div className="login_donot_forgot_section">
                                        Didn't forgot? <span className='pointer' onClick={() => { navigate("/login") }}>Click here to login</span>
                                    </div>
                                    <div
                                        className="login_btn"
                                        style={{
                                            color: !buttonLoader && "white",
                                            backgroundColor: !buttonLoader && "var(--theme-color)",
                                        }}
                                    >
                                        <UnstyledButton
                                            loading={buttonLoader}
                                            text="Update password"
                                            onClick={handleUpdatePassword}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="right_section">
                            <img src={cover_photo} alt="" />
                        </div>
                    </div >
            }
        </>
    )
}

export default ResetPassword